import { useParams } from "react-router-dom";
import OpenNoSqlDB from "./OpenNoSqlDB";
import OpenSQLDb from "./OpenSQLDb";

const OpenDatabase = () => {
    const { db_id } = useParams()

    if (db_id.startsWith("db-")) {
        return (
            <OpenNoSqlDB />
        )
    } else if(db_id.startsWith("sqldb-")) {
        return (
            <OpenSQLDb />
        )
    }else{
        return (
            <>No recognized DB</>
        )
    }

}

export default OpenDatabase